/**
 * MO Global Helpers - Shared utility functions
 * Migrated from src/alpine/utils/global.js
 *
 * NOTE: selectOption, selectOptionFrame, buildProperties now take explicit
 * `ctx` parameter instead of using Alpine `this` context.
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  /**
   * Select a product option variant (lens)
   * @param {Object} ctx - Component state containing rxLensProductOptions, rxLensSelectedVariant, rxLensProduct
   * @param {Object} optionObj - { name: string }
   * @param {string} optionValue - Selected value
   */
  function selectOption(ctx, optionObj, optionValue) {
    var selectedOption = ctx.rxLensProductOptions.find(function (o) {
      return o.name === optionObj.name;
    });
    var allWithout = selectedOption.values.filter(function (v) {
      return v !== optionValue;
    });
    var targetOptions = [optionValue].concat(
      ctx.rxLensSelectedVariant.options.filter(function (v) {
        return !allWithout.includes(v);
      })
    );

    ctx.rxLensProduct.variants.some(function (variant) {
      if (variant.options.every(function (opt) { return targetOptions.includes(opt); })) {
        ctx.rxLensSelectedVariant = variant;
        return true;
      }
    });
  }

  /**
   * Select a product option variant (frame)
   * @param {Object} ctx - Component state containing productOptions, selectedVariant, product
   * @param {Object} optionObj - { name: string }
   * @param {string} optionValue - Selected value
   */
  function selectOptionFrame(ctx, optionObj, optionValue) {
    var selectedOption = ctx.productOptions.find(function (o) {
      return o.name === optionObj.name;
    });
    var allWithout = selectedOption.values.filter(function (v) {
      return v !== optionValue;
    });
    var targetOptions = [optionValue].concat(
      ctx.selectedVariant.options.filter(function (v) {
        return !allWithout.includes(v);
      })
    );

    ctx.product.variants.some(function (variant) {
      if (variant.options.every(function (opt) { return targetOptions.includes(opt); })) {
        ctx.selectedVariant = variant;
        return true;
      }
    });
  }

  /**
   * Build cart properties object
   * @param {Object} ctx - Component state containing selectedVariant, rxLensSelectedVariant, etc.
   * @returns {Object} Properties for cart line item
   */
  function buildProperties(ctx) {
    var properties = {};
    properties["Frame SKU"] = ctx.selectedVariant.sku;

    if (ctx.rxLensSelectedVariant) {
      properties["Lens SKU"] = ctx.rxLensSelectedVariant.sku;
    }

    if (ctx.lensCoatingSelectedVariant && ctx.isAddedCoatingProduct) {
      properties["Coating SKU"] = ctx.lensCoatingSelectedVariant.sku;
    }

    return properties;
  }

  /**
   * Title case a string: "hello world" -> "Hello World"
   */
  function titleCase(str) {
    return str.toLowerCase().split(" ").map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(" ");
  }

  /**
   * Deep equality check for objects
   */
  function deepEqual(obj1, obj2) {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null) {
      return false;
    }
    var keys1 = Object.keys(obj1);
    var keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (var i = 0; i < keys1.length; i++) {
      if (!keys2.includes(keys1[i]) || !deepEqual(obj1[keys1[i]], obj2[keys1[i]])) {
        return false;
      }
    }
    return true;
  }

  /**
   * Scroll to a DOM element accounting for header height
   */
  function scrollToAnchor(node) {
    if (!node) return;
    var elementPosition = node.getBoundingClientRect().top;
    var headerHeight = parseFloat(
      document.documentElement.style.getPropertyValue("--header-height") || 0
    );
    var offsetPosition = elementPosition + window.pageYOffset - headerHeight;
    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  }

  // Array.prototype.equals polyfill (preserve existing behavior)
  if (Array.prototype.equals) {
    console.warn("Overriding existing Array.prototype.equals.");
  }
  Array.prototype.equals = function (array) {
    if (!array) return false;
    if (array === this) return true;
    if (this.length !== array.length) return false;
    for (var i = 0; i < this.length; i++) {
      if (this[i] instanceof Array && array[i] instanceof Array) {
        if (!this[i].equals(array[i])) return false;
      } else if (this[i] !== array[i]) {
        return false;
      }
    }
    return true;
  };
  Object.defineProperty(Array.prototype, "equals", { enumerable: false });

  window.MO.helpers = {
    selectOption: selectOption,
    selectOptionFrame: selectOptionFrame,
    buildProperties: buildProperties,
    titleCase: titleCase,
    deepEqual: deepEqual,
    scrollToAnchor: scrollToAnchor
  };
})();
